const RAW = process.env.REACT_APP_BACKEND_URL || "";
export const BACKEND_URL = RAW.replace(/\/$/, "");
export const API = `${BACKEND_URL}/api`;

const TOKEN_KEY = "amelprod_token";
export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => (t ? localStorage.setItem(TOKEN_KEY, t) : localStorage.removeItem(TOKEN_KEY));

function authHeaders(extra = {}) {
  const t = getToken();
  return t ? { ...extra, Authorization: `Bearer ${t}` } : extra;
}

async function handle(res) {
  if (res.status === 401) {
    setToken(null);
    window.dispatchEvent(new Event("amelprod-unauthorized"));
  }
  if (!res.ok) {
    const body = await res.json().catch(() => ({}));
    throw new Error(body.detail || `Eroare ${res.status}`);
  }
  return res.json();
}

export async function apiGet(path) {
  return handle(await fetch(`${API}${path}`, { headers: authHeaders() }));
}

export async function apiPost(path, data) {
  return handle(
    await fetch(`${API}${path}`, {
      method: "POST",
      headers: authHeaders({ "Content-Type": "application/json" }),
      body: JSON.stringify(data),
    })
  );
}

export async function apiPut(path, data) {
  return handle(
    await fetch(`${API}${path}`, {
      method: "PUT",
      headers: authHeaders({ "Content-Type": "application/json" }),
      body: JSON.stringify(data),
    })
  );
}

export async function apiDelete(path) {
  return handle(await fetch(`${API}${path}`, { method: "DELETE", headers: authHeaders() }));
}

export async function apiUpload(path, file) {
  const fd = new FormData();
  fd.append("file", file);
  return handle(await fetch(`${API}${path}`, { method: "POST", headers: authHeaders(), body: fd }));
}

export const sketchUrl = (comandaId, index) => `${API}/comenzi/${comandaId}/sketch/${index}`;

// Deschide un document obloane pre-randat (PDF/HTML) intr-o fila noua (cu Bearer -> blob).
export async function openObloaneDoc(comandaId, filename) {
  const res = await fetch(`${API}/comenzi/${comandaId}/obloane-document/${encodeURIComponent(filename)}`, {
    headers: authHeaders(),
  });
  if (res.status === 401) {
    setToken(null);
    window.dispatchEvent(new Event("amelprod-unauthorized"));
    throw new Error("Sesiune expirata");
  }
  if (!res.ok) {
    const body = await res.json().catch(() => ({}));
    throw new Error(body.detail || `Eroare ${res.status}`);
  }
  const blob = await res.blob();
  const url = URL.createObjectURL(blob);
  const w = window.open(url, "_blank");
  if (!w) {
    URL.revokeObjectURL(url);
    throw new Error("Fereastra a fost blocata de browser. Permite pop-up-urile.");
  }
  setTimeout(() => URL.revokeObjectURL(url), 60000);
}

// Descarca HTML-ul unui document (cu Bearer) si il deschide intr-o fila noua ca blob.
export async function openDocument(comandaId, tip) {
  const res = await fetch(`${API}/comenzi/${comandaId}/document/${tip}`, { headers: authHeaders() });
  if (res.status === 401) {
    setToken(null);
    window.dispatchEvent(new Event("amelprod-unauthorized"));
    throw new Error("Sesiune expirata");
  }
  if (!res.ok) {
    const body = await res.json().catch(() => ({}));
    throw new Error(body.detail || `Eroare ${res.status}`);
  }
  const htmlText = await res.text();
  const blob = new Blob([htmlText], { type: "text/html" });
  const url = URL.createObjectURL(blob);
  const w = window.open(url, "_blank");
  if (!w) {
    URL.revokeObjectURL(url);
    throw new Error("Fereastra a fost blocata de browser. Permite pop-up-urile.");
  }
  setTimeout(() => URL.revokeObjectURL(url), 60000);
}
